import { Component, signal, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DeckBoardComponent } from './deck-board.component';
import { AgentAdminComponent } from './agent-admin/agent-admin.component';

type DeckAdminTab = 'deck' | 'prompts';

/**
 * Live Call Management shell — a tabbed container (styled like Headline
 * Management) that hosts the deck board and the agent section (prompts +
 * voice-model catalog), both scoped to the CRM's globally-selected product.
 *
 * This component owns only the page title, the product badge, and the tab bar;
 * each tab body ({@link DeckBoardComponent}, {@link AgentAdminComponent}) is a
 * self-contained feature that resolves the product and loads its own data. Both
 * stay mounted (toggled with `hidden`) so switching tabs is instant and each
 * tab's state survives. It keeps the `DeckAdminComponent` name the menu route
 * already points at, so no route/registry change is needed.
 */
@Component({
  selector: 'app-deck-admin',
  standalone: true,
  imports: [CommonModule, DeckBoardComponent, AgentAdminComponent],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './deck-admin.component.html',
})
export class DeckAdminComponent {
  activeTab = signal<DeckAdminTab>('deck');

  /** Counts surfaced by each tab, shown as badges in the tab bar. */
  deckCount = signal<number | null>(null);
  promptCount = signal<number | null>(null);

  setTab(tab: DeckAdminTab): void {
    this.activeTab.set(tab);
  }
}
